
// // Function to change the text based on the current language
// function updateLanguageText() {
//   // Get all elements that contain the text you want to change
//   const textElements = document.querySelectorAll('.blog-list-section ul li .tag');

//   // Get the language of the page (you can modify how you detect the language)
//   const language = document.documentElement.lang; // or use other methods to detect language

//   // Loop through each element and check if it contains specific Japanese words
//   textElements.forEach(function(element) {
//     const text = element.textContent.trim();

//     // Translate 'ニュース' to 'News' if the language is English
//     if (text === 'お知らせ' && language === 'en') {
//       element.textContent = 'Notice';
//     } 
//     // Translate 'News' back to 'ニュース' if the language is Japanese
//     else if (text === 'Notice' && language === 'ja') {
//       element.textContent = 'お知らせ';
//     }

//     // Translate '製品' to 'Products' if the language is English
//     else if (text === '製品情報' && language === 'en') {
//       element.textContent = 'Product Information';
//     } 
//     // Translate 'Products' back to '製品' if the language is Japanese
//     else if (text === 'Product Information' && language === 'ja') {
//       element.textContent = '製品情報';
//     }
//   });
// }

// // Run the function on page load
// document.addEventListener('DOMContentLoaded', updateLanguageText);







document.addEventListener("DOMContentLoaded", function() {
  // Get the language from the <html> tag
  var pageLanguage = document.documentElement.lang;

  // Function to hide specific tags based on language
  function hideTags() {
    // Get all post-tags containers
    var postTagsContainers = document.querySelectorAll('.post-tags');

    postTagsContainers.forEach(function(container) {
      // If the language is English, hide the 3rd tag in each container
      if (pageLanguage === "en") {
        var thirdTag = container.querySelector('.tag:nth-child(2)');
        if (thirdTag) {
          thirdTag.style.display = 'none';
        }
      }

      // If the language is Japanese, hide the 1st tag in each container
      if (pageLanguage === "ja") {
        var firstTag = container.querySelector('.tag:nth-child(1)');
        if (firstTag) {
          firstTag.style.display = 'none';
        }
      }
    });
  }

  hideTags();
});


document.addEventListener("DOMContentLoaded", function() {
    // Select all elements with the class 'post-tags'
    var postTagsElements = document.querySelectorAll(".post-tags");

    // Loop through each element and remove the comma
    postTagsElements.forEach(function(postTags) {
        // Replace the comma and space between spans
        postTags.innerHTML = postTags.innerHTML.replace(", ", "");
    });
});





